import {createScreenshotPreference} from './screenshot-preference';
import './platform-screenshot.scss';

document.addEventListener('DOMContentLoaded', () => {
    const figures = document.querySelectorAll('[data-platform-screenshot], [data-guide-cover]');
    if (!figures.length) return;
    const preference = createScreenshotPreference(window);
    figures.forEach(figure => {
        const variants = JSON.parse(figure.dataset.screenshotVariants);
        const link = figure.querySelector('[data-guide-image]');
        const image = link?.querySelector('img') || figure.querySelector('[data-guide-cover-image]');
        const video = figure.querySelector('[data-guide-video]');
        const fallback = figure.querySelector('[data-screenshot-fallback]');
        const buttons = figure.querySelectorAll('[data-screenshot-platform]');
        if (video) {
            const device = figure.querySelector('[data-guide-video-device]');
            let hovering = false;
            let resumeAfterHover = false;
            const isFullscreen = () => document.fullscreenElement === video
                || document.webkitFullscreenElement === video || video.webkitDisplayingFullscreen;
            const resume = () => {
                if (!resumeAfterHover) return;
                resumeAfterHover = false;
                // Keep native controls usable if the browser blocks autoplay.
                video.play().catch(() => {});
            };
            device.addEventListener('pointerenter', event => {
                if (event.pointerType === 'touch' || isFullscreen()) return;
                hovering = true;
                resumeAfterHover = !video.paused;
                if (resumeAfterHover) video.pause();
            });
            device.addEventListener('pointerleave', () => {
                hovering = false;
                resume();
            });
            // Also pause autoplay after loading or switching platform while hovered.
            video.addEventListener('play', () => {
                if (!hovering || isFullscreen()) return;
                resumeAfterHover = true;
                video.pause();
            });
            const enterFullscreen = () => {
                if (!isFullscreen()) return;
                hovering = false;
                resume();
            };
            document.addEventListener('fullscreenchange', enterFullscreen);
            document.addEventListener('webkitfullscreenchange', enterFullscreen);
            video.addEventListener('webkitbeginfullscreen', enterFullscreen);
        }
        preference.subscribe(preferred => {
            const platform = variants[preferred] ? preferred : figure.dataset.defaultPlatform;
            const asset = variants[platform];
            if (figure.dataset.platform !== platform) {
                if (video) {
                    video.pause();
                    video.src = asset.video.src;
                    video.poster = asset.video.poster;
                    video.width = asset.video.width;
                    video.height = asset.video.height;
                    video.setAttribute('aria-label', asset.alt);
                    figure.querySelector('[data-guide-video-device]').style.cssText = asset.video.style;
                    figure.querySelector('.moto-guide-video-frame').src = asset.video.frame;
                    video.load();
                } else {
                    image.src = asset.src;
                    if (image.hasAttribute('srcset')) image.srcset = `${asset.src} 640w, ${asset.original} 1280w`;
                    image.width = asset.width;
                    image.height = asset.height;
                    image.alt = asset.alt || '';
                    if (link) {
                        link.href = asset.original;
                        link.setAttribute('aria-label', `${link.dataset.enlargeLabel}: ${asset.alt}`);
                    }
                }
                figure.dataset.platform = platform;
            }
            // Reserve an English-fallback note's space when only one platform is translated.
            fallback?.setAttribute('aria-hidden', String(asset.language !== 'en' || figure.dataset.screenshotLanguage === 'en'));
            buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.screenshotPlatform === platform)));
        });
        buttons.forEach(button => button.addEventListener('click', () => preference.select(button.dataset.screenshotPlatform)));
        const controls = figure.querySelector('[data-screenshot-controls]');
        if (controls) controls.hidden = false;
    });
});
